import { Collapse, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import { useState } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import { ExpandCollapseButton } from "../components/ExpandCollapseButton.tsx";
import type { SelectedCompany } from "./hooks/SelectedCompany";

export interface CompanyItemProps {
  company: SelectedCompany;
  companyBranding: ListItemData | undefined;
  Action?: JSX.Element;
  Summary?: JSX.Element;
}

export function CompanyMultipleReportsListItem({
  company,
  companyBranding,
  children,
  Action,
  Summary,
}: PropsWithChildren<CompanyItemProps>) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Paper variant="outlined" sx={(theme) => ({ borderColor: theme.palette.divider, width: "100%" })}>
      <Stack>
        <Stack direction="row" sx={{ pr: 1, alignItems: "center" }}>
          <Grid
            container
            sx={{ pr: 1, pl: 2, pt: 1.5, spacing: 1.5, alignItems: "center", direction: "row", width: "100%" }}
          >
            <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flexGrow: 1 }}>
              <img src={companyBranding?.iconSrc} alt="" width={24} height={24} />
              <Typography variant="subtitle1">{companyBranding?.label}</Typography>
            </Stack>
            {Action}
          </Grid>
        </Stack>
        <Grid container sx={{ width: "100%" }}>
          <Stack sx={{ flex: 1, width: "100%" }}>
            <Stack direction="row" sx={{ alignItems: "center", flexGrow: 1, pl: 1.5, pr: 2, pb: 0.5 }}>
              <ExpandCollapseButton expanded={expanded} onClick={setExpanded} />
              <Typography sx={{ color: "text.primary" }}>{company.reports.length} Reports</Typography>
              <HorizontalFill />
              {Summary}
            </Stack>
            <Collapse in={expanded}>
              <Divider />
              <Stack
                spacing={1}
                useFlexGap
                sx={{
                  p: 2,
                  bgcolor: "background.grey",
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                  width: "100%",
                }}
              >
                {children}
              </Stack>
            </Collapse>
          </Stack>
        </Grid>
      </Stack>
    </Paper>
  );
}
